import { useEffect, useState } from "react";
import * as S from "./style";
import LayoutDetails from "../../../LayoutModal/LayoutDetails";
import ImgTitle from "../../../../assets/promotion.svg";
import axiosInstance from "services/axiosInstance";
import Loading from "../../../Loading";
//hooks
import useLoading from "../../../../hooks/useLoading";
//Interface
import { IPromotion } from "Interfaces/IPromotion";
//Utils
import FormatarData from "utils/FormatData";
import { CurrencyFormat, formatPercentage } from "utils/CurrencyFormat";

interface IDetails {
  isOpenModalDetails: boolean;
  setModalClose: () => void;
  selectedUrlId: number | null;
}

export default function Details({
  isOpenModalDetails,
  setModalClose,
  selectedUrlId,
}: IDetails) {

  const [data, setData] = useState<IPromotion | null>(null);
  const { isLoading, startLoading, stopLoading } = useLoading();

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(`promotion/${selectedUrlId}`);
      setData(response.data);
      console.log('response: ', response.data);
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModalDetails && selectedUrlId !== null) {
      fetchData();
    }
  }, [isOpenModalDetails, selectedUrlId]);

  if (isOpenModalDetails) {
    return (
      <LayoutDetails
        title="Detalhes da Promoção"
        subTitle="Veja todos os detalhes disponíveis sobre a promoção."
        setModalClose={setModalClose}
      >
        {isLoading || !data ? (
          <Loading />
        ) : (
          <S.Content>
            <S.Header>
              <S.ContentImage>
                <S.Image src={ImgTitle} alt="Imagem Óculos" />
              </S.ContentImage>

              <S.ContentInfor>
                <S.Infor>
                  <p>Nome:</p>
                  <span>{data.title || "-"}</span>
                </S.Infor>
                <S.Infor>
                  <p>Autorização:</p>
                  <span>{data.auth || "-"}</span>
                </S.Infor>
                <S.Infor>
                  <p>Período:</p>
                  <span>
                    {
                      `${FormatarData(data.start, 'default-data') || "-"} à 
                    ${FormatarData(data.end, 'default-data') || "-"}`
                    }
                  </span>
                </S.Infor>
                <S.Infor>
                  <p>Status:</p>
                  <span>
                    {data.status || "0"}
                  </span>
                </S.Infor>

                <S.Infor>
                  <p>Vendedor Específico:</p>
                  <span>
                    {data.user?.first_name || "-"}
                  </span>
                </S.Infor>
              </S.ContentInfor>
            </S.Header>

            <S.Body>
              <S.Section>
                <S.InforBody>
                  <p>Desconto à vista (%)</p>
                  {data.cash_promotions.length > 0 &&
                    data.cash_promotions
                      .map((val, index) => {
                        return (
                          <span key={index}>
                            {val.payment_method?.payment_method || '-'}: {formatPercentage(parseFloat(val.discount || '0'))}
                          </span>
                        )
                      })
                  }
                </S.InforBody>
              </S.Section>

              <S.FeaturedSection>
                <S.InforBody>
                  <p>Desconto no Crédito (%)</p>
                  {data.credit_promotions.length > 0 &&
                    data.credit_promotions
                      .map((val, index) => {
                        return (
                          <span key={index}>
                            {val.installment || '-'}x {val.discount || '-'}%
                          </span>
                        )
                      })
                  }
                </S.InforBody>
              </S.FeaturedSection>

              <S.Section>
                <S.InforBody>
                  <p>Desconto no Crediário (%)</p>
                  <span>
                    {formatPercentage(parseFloat(data.payment_credit_promotion[0].discount || '0'))}
                  </span>

                </S.InforBody>
              </S.Section>

              <S.FeaturedSection>
                <S.InforBody>
                  <p>Características da Armação</p>
                  {data.filters.length > 0 ?
                    data.filters
                      .map((val, index) => {
                        return (
                          <span key={index}>
                            {val.type || '-'}: {val.name || '-'}
                          </span>
                        )
                      })
                    :
                    <span>
                      Aleatória
                    </span>
                  }
                </S.InforBody>
              </S.FeaturedSection>

              <S.InforBody>
                <S.InforSmall>Cadastrado em: {FormatarData(data.created_at || "-")}</S.InforSmall>
                <S.InforSmall>Ultima atualização em: {FormatarData(data.updated_at) || "-"}</S.InforSmall>
              </S.InforBody>
            </S.Body>
          </S.Content>
        )}
      </LayoutDetails>
    );
  }
  return null;
}
